export default {
  edit: "sitemap:edit",
  create: "sitemap:create",
  delete: "sitemap:delete",
  view: "sitemap:view",
};
